/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Adm_Err_Builtin_RoleInputs */

const en_adm_err_builtin_role = /** @type {(inputs: Adm_Err_Builtin_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Built-in roles cannot be changed or deleted.`)
};

const de_adm_err_builtin_role = /** @type {(inputs: Adm_Err_Builtin_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eingebaute Rollen können nicht geändert oder gelöscht werden.`)
};

/**
* | output |
* | --- |
* | "Built-in roles cannot be changed or deleted." |
*
* @param {Adm_Err_Builtin_RoleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const adm_err_builtin_role = /** @type {((inputs?: Adm_Err_Builtin_RoleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adm_Err_Builtin_RoleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_adm_err_builtin_role(inputs)
	return en_adm_err_builtin_role(inputs)
});